import { createColumnHelper } from '@tanstack/vue-table';

const columnHelper = createColumnHelper();

function createColumn(accessor, header, size, cell = ({ getValue }) => getValue()) {
  return columnHelper.accessor(accessor, {
    header,
    cell,
    size,
  });
}


export function getSubAccountColumns() {
  return [
    createColumn('username', 'Kullanıcı Adı', 376),
    createColumn('phoneNumber', 'Telefon', 237),
    createColumn('lastLoginDate', 'Son Giriş Zamanı', 237),
    createColumn('jobStatus', 'İşlem', 334),
  ];
}
